import React from 'react'
import {Link} from 'react-scroll'

function resumetop() {   
        return (           
            <div id="hi" className="featured  relative">
                <div className="container-fluid  ">                
                <div className="vh-100 slide-content topheader-title">
                    <div className="col-12 d-flex  vh-100">
                        <div className="topheader">
                        <div className="row col text-center">                         
                            <h3 className="text-center text-white"> Hi, I'm </h3>  
                            <h1 className="text-center">
                                Esteban Creasey <br></br>
                            </h1>                            
                            <div className="typewriter text-center" style={{display:"inline",width:"auto", margin: "auto"}}>                          
                                <h4 className="text-uppercase text-white" style={{display:"inline-block"}}>IT Manager, Fullstack Developer & More .<i className="fa fa-code"></i></h4>     
                            </div>                                                                                          
                        </div>                            
                        </div>
                    </div>
                </div>
                <div className="background">
                    <div className="cube"></div>
                    <div className="cube"></div>
                    <div className="cube"></div>
                    <div className="cube"></div>
                    <div className="cube"></div>
                </div>
                   
                </div>
                <Link to="about" spy={true} smooth={true}>
                    <h2 className="arrow-bottom"><i className="fa fa-arrow-circle-down"></i></h2>
                </Link>
                
            </div>
        )    
}



export default resumetop;
